import React, { useEffect } from 'react';

import { initializeSubscriptions } from '../stores/initSubscriptions';

export const AuthContextInitializator: React.FC = () => {
  useEffect(() => {
    console.debug('AuthContextInitializator invoked');
    initializeSubscriptions();
  }, []);
  return <></>;
};
